module.exports = __webpack_public_path__ + "static/media/Pikachu_gaussian2.35e5daed.png";